import React from 'react';
import { observer } from 'mobx-react';
import { NikoPatientPreviewTemplate } from 'themes/application/niko-patient/pages';
import { setCurrentView } from 'core/utils';
import { NikoPatientPreviewViewStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore) => new NikoPatientPreviewViewStore(rootStore), 'nikoPatientPreviewViewStore')
@observer
class NikoPatientPreview extends React.Component {
    render() {
        return <NikoPatientPreviewTemplate {...this.props} />
    }
}

export default NikoPatientPreview;